import SearchIcon from "@mui/icons-material/Search";
import TextField from "@mui/material/TextField";
import { InputAdornment, FormControl } from "@mui/material";

export default function SearchBar({name, label, placeholder, setQuery}) {
    return (
        <FormControl>
        <TextField
            id={name}
            label={label}
            placeholder={placeholder}
            onInput={(e) => {
                setQuery(e.target.value);
              }}
            InputProps={{
            startAdornment: (
                <InputAdornment position="start">
                <SearchIcon className="search-icon"/>
                </InputAdornment>
            ),
            }}
            variant="outlined"
        />
      </FormControl>
    );
}